 <!-- 周报表 -->
 <template>
    <diV style="background-color: white; height: calc(100vh - 84px); display: flex; flex-direction: column;">
        <el-form class="demo-form-inline" :inline="true" ref="weekReportForm" :model="weekReportForm" 
        size="mini" label-width="100px">
            <el-form-item label="仓库" prop="ckName">
                <el-select placeholder="请选择仓库" v-model="weekReportForm.ckName">
                    <el-option v-for="item in ckNameList" :key="item" :label="item" :value="item"> </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="日期范围" prop="date">
                <el-date-picker v-model="weekReportForm.date" type="daterange" align="right" unlink-panels @change="getData"
                    range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" :picker-options="pickerOptions">
                </el-date-picker>
            </el-form-item>
            <el-form-item label="">
                <el-button type="primary" @click="searchWeekReport">搜索</el-button>
                <el-button type="primary" @click="inventoryCountExport">导出</el-button>
            </el-form-item>
        </el-form>
        <div style="flex:1;overflow: hidden;">
            <!-- :column-config="{resizable: true,sortable: true,drag:true}" -->
            <vxe-table id="weekReportTable"  size="mini" ref="weekReportTable" :data="weekReportList" border stripe
            header-align="center"  max-height="60%"
            :row-config="{isCurrent: true, isHover: true}">
                <vxe-column field="signDay" :resizable="false" show-overflow width="170" align="center">
                    <template #header>
                        <div class="first-col">
                            <div class="first-col-top">项目</div>
                            <div class="first-col-bottom">日期</div>
                        </div>
                    </template>
                </vxe-column>
                <vxe-column field="inTons" title="入库（吨）" ></vxe-column>
                <vxe-column field="outTons" title="出库（吨）" ></vxe-column>
                <vxe-column field="stockTons" title="结存（吨）" ></vxe-column>
            </vxe-table>
            <vxe-table id="weekTypeReportTable"  size="mini" ref="weekTypeReportTable" :data="weekTypeReportList" border stripe
            header-align="center"  max-height="38%" style="margin-top: 20px;"
            :row-config="{isCurrent: true, isHover: true}">
                <vxe-column field="signDay" :resizable="false" show-overflow width="170" align="center">
                    <template #header>
                        <div class="first-col">
                            <div class="first-col-top">项目</div>
                            <div class="first-col-bottom">货物大类</div>
                        </div>
                    </template>
                </vxe-column>
                <vxe-column field="inTons" title="入库（吨）" ></vxe-column>
                <vxe-column field="outTons" title="出库（吨）" ></vxe-column>
                <vxe-column field="stockTons" title="结存（吨）" ></vxe-column>
            </vxe-table>
        </div>
    </diV>
</template>
<script>
import ExcelJS from 'exceljs';
import userProfile from '@/mixins/userProfile.js'
import basicData from '@/config/basicData.js'
import AEObasicData from '@/config/AEObasicData.js'
import clean from 'lodash-clean';
import { webapp_ws_ajax_run, webapp_urlprotocol_startup, urlAddRandomNo,webapp_ws_autoupdate, webapp_ws_ajax_together } from "../../utils/reports/grwebapp";

export default {
    name: 'weekReport',
    mixins: [userProfile],
    components:{

    },
    watch: { 
       
    },
    data() {
        return{
            weekReportForm:{
                ckName:"",
                date:'',
                startDate:"",
                endDate:"",
            },

            weekReportList:[],
            weekTypeReportList:[], // 货物大类
            ckNameList:[
                "纽约路仓库",
                "七星河路仓库",
                "外协库",
            ], // 获取仓库列表
            pickerOptions: {
                shortcuts: [{
                    text: '最近一周',
                    onClick(picker) {
                        const end = new Date();
                        const start = new Date();
                        start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                        picker.$emit('pick', [start, end]);
                    }
                },{
                    text: '最近一个月',
                    onClick(picker) {
                        const end = new Date();
                        const start = new Date();
                        start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                        picker.$emit('pick', [start, end]);
                    }
                }],
                disabledDate(time) {
                    const today = new Date();
                    today.setHours(0, 0, 0, 0);
                    // 只禁用大于今天的日期，今天可选
                    return time.getTime() > today.getTime();
                }
            },
        }
    },
    async created() {
        // 默认日期为当前一周
        const startDateObj = new Date(new Date().getTime() - 3600 * 1000 * 24 * 7)
        const endDateObj = new Date()
        // 赋值给日期选择器（el-date-picker daterange 接收Date数组）
        this.weekReportForm.date = [startDateObj, endDateObj]
        // 格式化赋值字符串 yyyy-MM-dd
        this.weekReportForm.startDate = this.formatDate(startDateObj)
        this.weekReportForm.endDate = this.formatDate(endDateObj)
        // await this.getckNameList()
        this.weekReportForm.ckName = this.ckNameList[0]
        this.wmsGetWeekReport()
        this.wmsGetWeekTypeReportBy()
    },
    mounted() {

    },
    methods: {
        // 日期转换
        formatDate(dateObj) {
            if (!dateObj) return ''
            const date = new Date(dateObj)
            const y = date.getFullYear()
            const m = String(date.getMonth() + 1).padStart(2, '0')
            const d = String(date.getDate()).padStart(2, '0')
            return `${y}-${m}-${d}`
        },
        // 获取日期
        getData(){
            this.weekReportForm.startDate = this.formatDate(this.weekReportForm.date[0])
            this.weekReportForm.endDate = this.formatDate(this.weekReportForm.date[1])
        },
        // 获取数据
        wmsGetWeekReport() { 
            return this.$api.wmsGetWeekReport(this.weekReportForm.ckName,this.weekReportForm.startDate,this.weekReportForm.endDate ).then(res =>{
                this.weekReportList = res
            })
        },
        // 货物大类数据
        wmsGetWeekTypeReportBy(){
            return this.$api.wmsGetWeekTypeReportBy(this.weekReportForm.ckName,this.weekReportForm.startDate,this.weekReportForm.endDate ).then(res =>{
                this.weekTypeReportList = res
            })
        },
        // 搜索
        searchWeekReport(){
            this.wmsGetWeekReport()
            this.wmsGetWeekTypeReportBy()
        },
        // 获取仓库
        // getckNameList(){
        //     return this.$api.getCkNamesBy(  ).then(res =>{
        //        this.ckNameList = res
        //        this.weekReportForm.ckName = this.ckNameList[0]
        //     })
        // },
        // 导出
        async inventoryCountExport(){
            // 定义三个接收数组
            let table1 = [];
            let table2 = [];
            let table3 = [];
            let goodsType1 = [];
            let goodsType2 = [];
            let goodsType3 = [];

            // 收集所有异步请求 Promise
            const reqList = [];
            const ckList = this.ckNameList.slice(0, this.ckNameList.length); // 防止超出

            for (let i = 0; i < ckList.length; i++) {
                const item = ckList[i];
                const p1 = this.$api.wmsGetWeekReport(
                    item,
                    this.weekReportForm.startDate,
                    this.weekReportForm.endDate
                ).then(res => {
                    // 根据下标赋值到对应数组
                    if (i === 0) table1 = res;
                    if (i === 1) table2 = res;
                    if (i === 2) table3 = res;
                });
                const p2 = this.$api.wmsGetWeekTypeReportBy(
                    item,
                    this.weekReportForm.startDate,
                    this.weekReportForm.endDate
                ).then(res => {
                    if (i === 0) goodsType1 = res;
                    if (i === 1) goodsType2 = res;
                    if (i === 2) goodsType3 = res;
                });
                // 把当前仓库的两个请求打包成一个Promise，两个都完成才算这个仓库结束
                const pAll = Promise.all([p1, p2]);
                reqList.push(pAll);
            }

            // 等待全部接口请求完成再组装参数
            await Promise.all(reqList);
            var master = {
                ckName1: table1?table1[0].ckName:'',
                ckName2: table2?table2[0].ckName:'',
                ckName3: table3?table3[0].ckName:'',
                startDate: this.weekReportForm.startDate,
                endDate: this.weekReportForm.endDate
            }
            const params = { 
                master:master,
                table1, // 纽约路仓库
                table2, // 七星河
                table3, // 外协
                goodsType1,
                goodsType2,
                goodsType3,
            }
            let downloadName = `周报表_${this.weekReportForm.startDate}_${this.weekReportForm.endDate}.xls`
            var args = {
                report: urlAddRandomNo("/grf/周报表.grf"),
                data: params,
                type: "xls",
                filename: downloadName,
                ExportPageBreak: false, // 导出Excel时是否保留分页符
                ExportPageHeaderFooter: false, // 导出Excel时是否保留页眉页脚
                SameAsPrint: false, // 导出Excel时是否与和纸质打印一致
                showOptionDlg: true, // 是否弹出导出设置弹窗
                ExcelKeepCellFormat: true,// 导出Excel时是否保持单元格格式
            };
            webapp_ws_ajax_run(args);
        },
    }
}
</script>
<style lang="less" scoped>
.first-col {
    position: relative;
    height: 20px;
}
.first-col:before {
    content: "";
    position: absolute;
    left: -15px;
    top: 10px;
    width: 180px;
    height: 1px;
    transform: rotate(18deg);
    background-color: #e8eaec;
}
.first-col .first-col-top {
    position: absolute;
    right: 4px;
    top: -10px;
}
.first-col .first-col-bottom {
    position: absolute;
    left: 4px;
    bottom: -10px;
}
</style>